<template>
    <div>
        <Navbar class="bg-white" />
        <PageTitle pageTitle="Testimonial" />
        <Testimonial />
        <WhyChooseUs />
        <!-- <Newsletter /> -->
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import Testimonial from '../Common/Testimonial.vue'
import WhyChooseUs from '../About/WhyChooseUs.vue'
// import Newsletter from '../Common/Newsletter'
import Footer from '../Layout/Footer'

export default {
    name: 'TestimonialPage',
    components: {
        Navbar,
        PageTitle,
        Testimonial,
        WhyChooseUs,
        // Newsletter,
        Footer,
    }
}
</script>